import React from 'react';

import { EditorContainer } from '../layout/Builder.jsx';
import Defaults from '../layout/Defaults.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';

const ButtonType = {
    Accept: 'accept',
    Reject: 'reject',
    
    fromBlockConfig: (blockConfig) => blockConfig.config && blockConfig.config.block && blockConfig.config && blockConfig.config.block.buttonType
};

function Component(props) {
    // TODO check show cookie policy bit from Manager (props.config.?)
    const [visible, setVisible] = React.useState(props.builder);
    React.useEffect(() => {
        if (props.builder) {
            return;
        }
        setVisible(window && window.cookie && window.cookie.getCookie(cookie._cookiePolicy) != 'shown');
    }, []);
    if (!visible) {
        return null;
    }
    const handleAccept = () => {
        console.log('accept');
        handleClose();
    }
    const handleReject = () => {
        console.log('reject');
        handleClose();
    }
    const handleClose = () => {
        if (props.builder) {
            return;
        }
        if (window && window.cookie) {
            cookie.setCookie(cookie._cookiePolicy, 'shown', 60)
        }
        setVisible(false);
    }
    let contentConfig = props.contentConfig;
    if (!contentConfig) {
        contentConfig = props.config && props.config.documents && props.config.documents[PageType.CookiePolicy];
    }
    if (!contentConfig) {
        if (!props.builder) {
            // No config saved => Don't render cookie policy on live site
            return null;
        }
        // Use default design in builder context
        contentConfig = Defaults.PageConfig[PageType.CookiePolicy](props.config);
    }

    let blocks = [];
    let containerProps;
    if (contentConfig.desktop && contentConfig.desktop.blocks) {
        blocks = contentConfig.desktop.blocks;
        containerProps = contentConfig.desktop.page;
    }
    const handleBlockProps = (d) => {
        if (!d.type) {
            return;
        }
        const blockProps = { inPopup: true };
        switch (d.type.value) {
            case Name.Block.CookiePolicy.Button.Accept:
            case Name.Block.CookiePolicy.Button.Reject:
                const buttonType = ButtonType.fromBlockConfig(d);
                switch (buttonType) {
                    case ButtonType.Reject:
                        blockProps.onButtonClick = handleReject;
                        break;
                    default:
                        blockProps.onButtonClick = handleAccept;
                        break;
                }
                break;
        }
        return blockProps;
    }
    const handleContent = (content, style) => {
        return <div style={style}>{content}</div>
    }
    const containerStyle = {};
    const handleMapStyleConfigProp = (_, propName, propValue, propUnit, style) => {
        switch (propName) {
            case 'alignment':
                switch (propValue) {
                    case 'tl':
                        containerStyle.left = 0;
                        containerStyle.top = 0;
                        break;
                    case 'tc':
                        containerStyle.left = '50%';
                        containerStyle.top = 0;
                        containerStyle.transform = 'translateX(-50%)';
                        break;
                    case 'tr':
                        containerStyle.right = 0;
                        containerStyle.top = 0;
                        break;
                    case 'ml':
                        containerStyle.left = 0;
                        containerStyle.top = '50%';
                        containerStyle.transform = 'translateY(-50%)';
                        break;
                    case 'mc':
                        containerStyle.left = '50%';
                        containerStyle.top = '50%';
                        containerStyle.transform = 'translateX(-50%) translateY(-50%)';
                        break;
                    case 'mr':
                        containerStyle.right = 0;
                        containerStyle.top = '50%';
                        containerStyle.transform = 'translateY(-50%)';
                        break;
                    case 'bl':
                        containerStyle.bottom = 0;
                        containerStyle.left = 0;
                        break;
                    case 'bc':
                        containerStyle.bottom = 0;
                        containerStyle.left = '50%';
                        containerStyle.transform = 'translateX(-50%)';
                        break;
                    case 'br':
                        containerStyle.bottom = 0;
                        containerStyle.right = 0;
                        break;
                }
                return true;
            case 'maxWidth':
                if (!props.builder) {
                    if (propValue) {
                        style.width = `${propValue}${propUnit}`;
                    }
                    return true;
                } else if (propUnit == 'vw') {
                    return true;
                }
                break;
        }
    }
    return (
        <EditorContainer
            {...props}
            blockPropsHandler={handleBlockProps}
            blocks={blocks}
            className="cont__cookies"
            containerProps={containerProps}
            style={containerStyle}
            onContainerProps={props.onPageProps}
            onContent={handleContent}
            onMapStyleConfigProp={handleMapStyleConfigProp} />
    )
}

export { ButtonType, Component };